import { customElement, useView } from 'aurelia-templating';
import { PLATFORM } from 'aurelia-framework';
import { widget } from '../../widgets/widget-decorator';
import { BindingEngine, Disposable } from 'aurelia-binding';
import { WidgetBase } from '../widget-base';
import { CustomerService } from '../../services/customer-service';
import { WidgetPropertyType } from '../widget-property-type';
import { property } from '../property-decorator';

@customElement('customer-name-widget')
@useView(PLATFORM.moduleName('./customer-name-widget.html'))
@widget({ name: 'Customer name', canUseInReport: true, canUseInDashboard: true, description: 'Displays the name of the customer', defaultWidth: 27, defaultHeight: 12 })
export class CustomerNameWidget extends WidgetBase {
  constructor(element: Element, customerService: CustomerService, bindingEngine: BindingEngine) {
    super(element, bindingEngine, customerService);
    this.title = 'Customer name:';
    this.titleFontSize = 14;
  }

  @property('Text')
  font?: string;

  @property('Text')
  fontSize?: number = 18;

  @property('Text')
  color?: string;

  @property('Text', 'Alignment', WidgetPropertyType.List, [{ value: 'left', label: 'Left' }, { value: 'center', label: 'Center' }, { value: 'right', label: 'Right' }])
  textAlign?: 'left' | 'center' | 'right';

  fontSub: Disposable;
}
